import Vue from 'vue'

import VRuntimeTemplate from 'v-runtime-template'
Vue.component('v-runtime-template', VRuntimeTemplate)
